import { NavLink } from 'react-router-dom';
import { clsx } from 'clsx';
import { useAuth } from '../../hooks/useAuth';

const NAV = [
  { to: '/dashboard', label: 'Dashboard', icon: '◈' },
  { to: '/analytics', label: 'Analytics', icon: '◉' },
];

export function Sidebar() {
  const { user, logout } = useAuth();

  return (
    <aside className="w-60 min-h-screen bg-falcon-navy flex flex-col">
      <div className="px-6 py-5 border-b border-falcon-navy-light">
        <span className="font-display font-bold text-white text-lg tracking-tight">
          Falcon <span className="text-falcon-gold">MOS</span>
        </span>
      </div>

      <nav className="flex-1 px-3 py-4 space-y-1">
        {NAV.map(({ to, label, icon }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              clsx(
                'flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-body font-medium transition-colors',
                isActive
                  ? 'bg-falcon-blue text-white'
                  : 'text-gray-300 hover:bg-falcon-navy-light hover:text-white'
              )
            }
          >
            <span className="text-base">{icon}</span>
            {label}
          </NavLink>
        ))}
      </nav>

      <div className="px-4 py-4 border-t border-falcon-navy-light">
        <div className="flex items-center gap-3 mb-3">
          {user?.photoURL && (
            <img
              src={user.photoURL}
              alt={user.displayName ?? ''}
              className="w-8 h-8 rounded-full"
            />
          )}
          <div className="flex-1 min-w-0">
            <p className="text-xs font-medium text-white truncate">
              {user?.displayName}
            </p>
            <p className="text-xs text-gray-400 truncate">{user?.email}</p>
          </div>
        </div>
        <button
          onClick={logout}
          className="w-full text-xs text-gray-400 hover:text-white text-left transition-colors"
        >
          Sign out
        </button>
      </div>
    </aside>
  );
}
